import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const InfoAlt: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5,8 C5,7.22030388 5.63206859,6.58823529 6.41176471,6.58823529 L8.76470588,6.58823529 C9.544402,6.58823529 10.1764706,7.22030388 10.1764706,8 L10.1764706,14.5882353 C10.1764706,15.3679314 9.544402,16 8.76470588,16 C7.98500976,16 7.35294118,15.3679314 7.35294118,14.5882353 L7.35294118,9.41176471 L6.41176471,9.41176471 C5.63206859,9.41176471 5,8.77969612 5,8 L5,8 Z"
            ></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.94117647,2.35294118 C5.94117647,1.05344765 6.99462412,0 8.29411765,0 C9.59361118,0 10.6470588,1.05344765 10.6470588,2.35294118 C10.6470588,3.65243471 9.59361118,4.70588235 8.29411765,4.70588235 C6.99462412,4.70588235 5.94117647,3.65243471 5.94117647,2.35294118 L5.94117647,2.35294118 Z"
            ></path>
        </Icon>
    );
};
